import { useLocation, useNavigate, useParams } from "react-router-dom";
import Styles from "./styles.module.scss";
import useQuery from "@Hooks/useQuery";
import { useEffect, useMemo, useState } from "react";
import { useDebounce } from "@Hooks/useDebounce";
import Icon from "@Atom/Icon";
import SearchBar from "@Atom/SearchBar";
import moment from "moment";
import CustomTable from "@Molecule/CustomTable";
import { fileBaseUrl } from "@Config/api";
import Images from "@Theme/Images";
import useWindowSize from "@Hooks/useWindowSize";
import Toast from "@Atom/Toast";
import ModalWrapper from "@Atom/ModalWrapper";
import JobActionsModal from "../JobList/JobActionsModal";
import DetailCandidateModal from "./DetailCandidateModal";

export default function CandidatePerJobPost({ data }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const query = useQuery();
  const { id } = useParams();

  const { width } = useWindowSize();

  const [searchName, setSearchName] = useState(query?.get("s") || "");
  const [limit, setLimit] = useState(+query?.get("l") || 10);
  const [pages, setPages] = useState(+query?.get("p") || 1);
  const [trigger, setTrigger] = useState(query?.get("tr") || "");
  const [success, setSuccess] = useState("");
  const [openAction, setOpenAction] = useState(null);
  const [showDetail, setShowDetail] = useState(null);

  const debounceSearch = useDebounce(searchName, 300);

  useEffect(() => {
    navigate(
      `${pathname}?l=${limit || 10}&p=${pages || 1}&s=${
        debounceSearch || ""
      }&tr=${trigger || ""}`,
      {
        replace: true,
      }
    );
  }, [navigate, pathname, limit, pages, debounceSearch, trigger]);

  const templateData = useMemo(() => {
    return {
      data:
        data?.response?.data?.candidates?.length > 0
          ? data?.response?.data?.candidates
          : [],
      columns: [
        {
          name: "name",
          label: "Nama",
          minWidth: "250px",
          maxWidth: "250px",
          thClassName: width <= 768 ? "" : Styles.stickyLeftName,
          tdClassName: width <= 768 ? "" : Styles.stickyLeftName,
          showRightSeparator: true,
          renderData: (row) => (
            <div className={Styles.nameBoxRow}>
              <div className={Styles.images}>
                <img
                  src={
                    row?.profilePic
                      ? fileBaseUrl + row?.profilePic
                      : Images.AVA_DEFAULT
                  }
                  alt=""
                />
              </div>
              <span className={Styles.titleName}>{row?.name || "-"}</span>
            </div>
          ),
        },
        {
          name: "phoneNumber",
          label: "No Telp & Email",
          minWidth: "250px",
          renderData: (row) => (
            <div className={Styles.phoneNumberRow}>
              <div>
                <div>
                  <Icon icon={"phone"} size={16} color={"#1571DE"} />
                </div>
                <span>{row?.phoneNumber || "-"}</span>
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    navigator.clipboard
                      .writeText(row?.phoneNumber)
                      .then(() => {
                        setSuccess("Link berhasil disalin");
                      })
                      .catch((error) => {
                        // Tangani error jika copy ke clipboard gagal
                        console.error("Gagal menyalin ke clipboard:", error);
                      });
                  }}
                >
                  <Icon icon={"duplicate"} size={16} color={"#1571DE"} />
                </div>
              </div>
              <div>
                <div>
                  <Icon icon={"email"} size={16} color={"#1571DE"} />
                </div>
                <span>{row?.email || "-"}</span>
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    navigator.clipboard
                      .writeText(row?.email)
                      .then(() => {
                        setSuccess("Link berhasil disalin");
                      })
                      .catch((error) => {
                        // Tangani error jika copy ke clipboard gagal
                        console.error("Gagal menyalin ke clipboard:", error);
                      });
                  }}
                >
                  <Icon icon={"duplicate"} size={16} color={"#1571DE"} />
                </div>
              </div>
            </div>
          ),
        },
        {
          name: "address",
          label: "Alamat Domisili",
          minWidth: "250px",
          renderData: (row) => <span>{row?.address || "-"}</span>,
        },
        {
          name: "lastPosition",
          label: "Posisi Sebelumnya",
          minWidth: "250px",
          renderData: (row) => <span>{row?.lastPosition || "-"}</span>,
        },
        {
          name: "lastCompany",
          label: "Tempat Kerja Sebelumnya",
          minWidth: "250px",
          renderData: (row) => <span>{row?.lastCompany || "-"}</span>,
        },
        // {
        //   name: "lastEducation",
        //   label: "Pendidikan Terakhir",
        //   minWidth: "180px",
        // },
        {
          name: "experienceDuration",
          label: "Jumlah Pengalaman",
          minWidth: "250px",
          renderData: (row) => <span>{row?.experienceDuration || "-"}</span>,
        },
        {
          name: "appliedDate",
          label: "Tanggal Melamar",
          minWidth: "250px",
          renderData: (row) => (
            <span>
              {row?.appliedDate
                ? moment(new Date(row?.appliedDate)).format("DD MMMM YYYY")
                : "-"}
            </span>
          ),
        },
        {
          name: "action",
          label: "Action",
          minWidth: "80px",
          align: "center",
          renderData: (row) => (
            <div className={Styles.actonsRow}>
              <Icon
                icon={"video"}
                color={row?.videoProfile ? "#1571DE" : "#E0E0E0"}
                size={24}
                className={
                  row?.videoProfile ? Styles.icon : Styles.iconDisabled
                }
                onClick={(e) => {
                  if (row?.videoProfile) {
                    e.stopPropagation();
                    window.open(row?.videoProfile);
                  }
                }}
              />
              <Icon
                icon={"file"}
                color={row?.cv ? "#1571DE" : "#E0E0E0"}
                size={24}
                className={row?.cv ? Styles.icon : Styles.iconDisabled}
                onClick={(e) => {
                  if (row?.cv) {
                    e.stopPropagation();
                    window.open(fileBaseUrl + row?.cv);
                  }
                }}
              />
            </div>
          ),
        },
      ],
    };
  }, [data, width]);

  useEffect(() => {
    setTimeout(() => {
      if (success) setSuccess("");
    }, 2000);
  }, [success]);

  useEffect(() => {
    const previousPage = pages;
    if (+data?.response?.totalData === 1 || +data?.response?.totalData === 0) {
      setPages(1);
    } else {
      const validPage = Math.max(
        1,
        Math.min(previousPage, +data?.response?.totalPage)
      );
      setPages(validPage);
    }
  }, [pages, data]);

  useEffect(() => {
    if (openAction || showDetail) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.removeProperty("overflow");
    }
  }, [openAction, showDetail]);

  return (
    <div className={Styles.container}>
      <div className={Styles.content}>
        <div className={Styles.header}>
          <div
            className={Styles.linkBack}
            onClick={() => {
              navigate(`/business/dashboard/job-list`);
            }}
          >
            <div>
              <Icon icon={"arrow-left"} size={24} color={"#0A0A0A"} />
            </div>
            <span>{data?.response?.data?.jobPostTitle || "-"}</span>
          </div>

          <div className={Styles.buttonAction}>
            {data?.response?.data?.jobPostStatus !== "Unpublish" && (
              <button
                onClick={() => {
                  setOpenAction({
                    type: "Tutup Loker",
                    data: {
                      id: id,
                    },
                  });
                }}
              >
                <Icon icon={"close-square"} size={20} color={"#D42701"} />
                Tutup Loker
              </button>
            )}

            <button
              onClick={() => {
                navigate(
                  `/business/dashboard/job-list/create?id=${id}&fr=detail`
                );
              }}
            >
              <Icon icon={"briefcase-v2"} size={20} color={"#FFFFFF"} />
              Edit Loker
            </button>
          </div>
        </div>

        <div className={Styles.contentTable}>
          <div className={Styles.tableHeader}>
            <SearchBar
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
              placeholder={"Search"}
              type={"none"}
              backgroundColorIcon="#fff"
            />

            <div className={Styles.expiredDate}>
              <div>
                <Icon icon={"information-solid"} color={"#1571DE"} size={16} />
              </div>

              <span>
                Masa Aktif Loker:{" "}
                {data?.response?.data?.jobPostExpiredDate
                  ? Math.max(
                      0,
                      moment(
                        new Date(data?.response?.data?.jobPostExpiredDate)
                      )?.diff(moment(), "days")
                    )
                  : "0"}{" "}
                Hari
              </span>
            </div>
          </div>

          <CustomTable
            onClickRow={(row) => setShowDetail(row)}
            columns={templateData?.columns}
            data={templateData?.data || []}
            type={width <= 768 ? "" : "sticky-left-right"}
            value={+limit}
            setValue={setLimit}
            selectedPage={+pages}
            setSelectedPage={setPages}
            totalPage={data?.response?.totalPage || 1}
            totalData={data?.response?.totalData || 0}
            withNumbering
            maxWidthNumbering="50px"
            minHeight="450px"
            isV2
            isDashBoardBusiness
            noStickyPagination
            labelTotal="Data"
            bgColorPagination="#ededed"
            isLoadingSkeleton={
              query?.get("s") !== searchName ||
              +query?.get("p") !== +pages ||
              +query?.get("l") !== +limit ||
              +query?.get("tr") !== +trigger
            }
          />
        </div>

        <Toast isSent={success} label={success} />
      </div>

      {showDetail && (
        <ModalWrapper
          isLandingPage
          show={showDetail}
          handleClose={() => {
            setShowDetail(null);
          }}
        >
          <DetailCandidateModal
            data={showDetail}
            handleClose={() => {
              setShowDetail(null);
            }}
            setSuccess={setSuccess}
          />
        </ModalWrapper>
      )}

      {openAction && (
        <ModalWrapper
          isLandingPage
          show={openAction}
          handleClose={() => {
            setOpenAction(null);
          }}
        >
          <JobActionsModal
            handleClose={() => {
              setOpenAction(null);
            }}
            data={openAction}
            setTrigger={setTrigger}
            setSuccess={setSuccess}
            // isDetail
          />
        </ModalWrapper>
      )}
    </div>
  );
}
